import React from 'react';
import { TextField, Zoom } from '@mui/material';

// temp component to override transition component to avoid issue due to safari CSS bug
// https://github.com/mui/material-ui/pull/32202
const TempTextField = props => {
  const { select, SelectProps, InputProps, inputProps, InputLabelProps, slotProps: slotPropsProp, ...rest } = props;

  const slotProps = { ...slotPropsProp };
  const ignoreAutofillProps = {
    'data-1p-ignore': 'true',
    'data-lpignore': 'true',
    'data-bwignore': 'true',
    'data-dashlane-disabled-on-field': 'true',
    'data-form-type': 'other',
    autoComplete: 'new-password'
  };

  if (InputProps) slotProps.input = { ...InputProps, ...slotProps.input };
  slotProps.htmlInput = {
    ...ignoreAutofillProps,
    ...inputProps,
    ...slotProps.htmlInput
  };
  if (InputLabelProps) slotProps.inputLabel = { ...InputLabelProps, ...slotProps.inputLabel };

  if (select) {
    const { MenuProps, ...other } = SelectProps || {};
    slotProps.select = {
      MenuProps: {
        TransitionComponent: Zoom,
        ...MenuProps
      },
      ...other,
      ...slotProps.select
    };
  }

  return <TextField select={select} {...rest} slotProps={slotProps} />;
};

export default TempTextField;
